import React from 'react'
import { graphql } from 'gatsby'
import { Trans } from 'gatsby-plugin-react-i18next'
import { Seo } from '../components/SEO'

import MHeroVideo from '../assets/video/mobile/mobile_KV10.mp4'
import THeroVideo from '../assets/video/tablet/tablet_KV10.mp4'
import DHeroVideo from '../assets/video/desktop/desktop_KV10.mp4'
import MSplitVideo from '../assets/video/mobile/mobile_KV11.mp4'
import TSplitVideo from '../assets/video/tablet/tablet_KV11.mp4'
import DSplitVideo from '../assets/video/desktop/desktop_KV11.mp4'
import MSplitVideo2 from '../assets/video/mobile/mobile_KV16.mp4'
import TSplitVideo2 from '../assets/video/tablet/tablet_KV16.mp4'
import DSplitVideo2 from '../assets/video/desktop/desktop_KV16.mp4'

import ProductsHero from '../components/ProductsHero'

import RenderVideo from '../components/RenderVideo'
import TilesSwiper2 from '../components/TilesSwiper2'

import Icon1 from '../assets/svg/Products-icon1.inline.svg'
import Icon11 from '../assets/svg/Products-icon11.inline.svg'
import Icon12 from '../assets/svg/Products-icon12.inline.svg'
import Icon15 from '../assets/svg/Products-icon15.inline.svg'
import Icon21 from '../assets/svg/Products-icon21.inline.svg'
import Icon26 from '../assets/svg/Products-icon26.inline.svg'

import Icon28 from '../assets/svg/Products-icon28.inline.svg'
import Icon29 from '../assets/svg/Products-icon29.inline.svg'
import Icon36 from '../assets/svg/Products-icon36.inline.svg'

import Icon30 from '../assets/svg/Products-icon30.inline.svg'
import Icon31 from '../assets/svg/Products-icon31.inline.svg'
import Icon32 from '../assets/svg/Products-icon32.inline.svg'
import Icon33 from '../assets/svg/Products-icon33.inline.svg'

import SelectedProducts from '../components/SelectedProducts'
import SectionTextVideo from '../components/SectionTextVideo'

import SectionBigTile from '../components/SectionBigTile'

import MTechVideo from '../assets/video/mobile/mobile_KV12.mp4'
import TTechVideo from '../assets/video/tablet/tablet_KV12.mp4'
import DTechVideo from '../assets/video/desktop/desktop_KV12.mp4'
import SectionOrder from '../components/SectionOrder'

const SlideTiles1 = [
  {
    content: <Trans>SlideTilesContent1_1</Trans>,
    icon: <Icon36 />,
  },
  {
    content: <Trans>SlideTilesContent1_2</Trans>,
    icon: <Icon11 />,
  },
  {
    content: <Trans>SlideTilesContent1_3</Trans>,
    icon: <Icon28 />,
  },
  {
    content: <Trans>SlideTilesContent1_4</Trans>,
    icon: <Icon12 />,
  },
  {
    content: <Trans>SlideTilesContent1_5</Trans>,
    icon: <Icon29 />,
  },

  {
    content: <Trans>SlideTilesContent1_6</Trans>,
    icon: <Icon30 />,
  },
  {
    content: <Trans>SlideTilesContent1_7</Trans>,
    icon: <Icon31 />,
  },
]

const SlideTiles2 = [
  {
    content: <Trans>SlideTilesContent2_1</Trans>,
    icon: <Icon36 />,
  },
  {
    content: <Trans>SlideTilesContent2_2</Trans>,
    icon: <Icon28 />,
  },
  {
    content: <Trans>SlideTilesContent2_3</Trans>,
    icon: <Icon21 />,
  },
  {
    content: <Trans>SlideTilesContent2_4</Trans>,
    icon: <Icon32 />,
  },
  {
    content: <Trans>SlideTilesContent2_5</Trans>,
    icon: <Icon33 />,
  },
  {
    content: <Trans>SlideTilesContent2_6</Trans>,
    icon: <Icon29 />,
  },
]

const SlideTiles3 = [
  {
    content: <Trans>SlideTilesContent3_1</Trans>,
    icon: <Icon36 />,
  },
  {
    content: <Trans>SlideTilesContent3_2</Trans>,
    icon: <Icon26 />,
  },
]

const cs_voyager = () => {
  return (
    <>
      <ProductsHero
        id='voyagerHero'
        whereToScroll='VoyagerScroll'
        title={<Trans>ProductsHeroTitle</Trans>}
        heading={<Trans>ProductsHeroHeading</Trans>}
        description={<Trans>ProductsHeroDescription</Trans>}
        MHeroVideo={MHeroVideo}
        THeroVideo={THeroVideo}
        DHeroVideo={DHeroVideo}
        scrollBtnStyles='lg:block'
      />
      <SectionTextVideo
        id='VoyagerTextVideo1'
        scrollId='VoyagerScroll'
        styleList='bg-black-100 text-white'
        heading={<Trans>SectionTextVideoHeading</Trans>}
        content={<Trans>SectionTextVideoContent</Trans>}
        videoM={MSplitVideo}
        videoT={TSplitVideo}
        videoD={DSplitVideo}
      />
      <div className='relative w-screen xl:h-[1080px] lg:h-[800px] md:h-[1194px] md:overflow-auto md:flex md:flex-col  h-[800px] text-black-100  overflow-hidden flex items-end'>
        <RenderVideo
          id='cs-voyager'
          videoM={MTechVideo}
          videoT={TTechVideo}
          videoD={DTechVideo}
          classList={
            'xl:max-w-[1920px] xl:left-1/2 xl:-translate-x-1/2 lg:absolute lg:h-full md:h-[597px] md:relative absolute object-cover h-full object-cover w-screen -z-[1]'
          }
        />

        <div className='container lg:pt-[260px] md:pt-[175px] pt-[70px] md:bg-white lg:bg-transparent md:h-[597px] lg:h-auto'>
          <h2
            className='md:text-left lg:max-w-[500px] md:max-w-[300px]  lg:text-6xl md:text-4xl  text-3xl  mb-[25px]'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
          >
            <Trans>SectionMobileVideoHeading</Trans>
          </h2>
          <p
            className='lg:text-lg md:max-w-[600px] lg:max-w-[500px]'
            data-aos='fade-up'
            data-aos-duration='500'
            data-aos-easing='ease-in-out'
          >
            <Trans>SectionMobileVideoContent</Trans>
          </p>
          <br />
        </div>
      </div>
      <div className='pt-[75px] lg:block hidden bg-gray-100'></div>
      <TilesSwiper2
        SlideTiles={SlideTiles1}
        TileStyle='min-h-[160px] justify-center'
        GridStyles='lg:grid-cols-[repeat(4,_minmax(0,_1fr))] lg:gap-[17px]  grid-cols-2 auto-rows-fr gap-[15px]'
        heading={<Trans>SectionTilesSwiperHeading1</Trans>}
      />
      <TilesSwiper2
        SlideTiles={SlideTiles2}
        TileStyle='min-h-[160px] justify-center'
        GridStyles='lg:grid-cols-[repeat(4,_minmax(0,_1fr))] lg:gap-[17px] grid-cols-2 gap-[15px] w-[100%]  '
        heading={<Trans>SectionTilesSwiperHeading2</Trans>}
      />
      <TilesSwiper2
        SlideTiles={SlideTiles3}
        TileStyle='min-h-[160px] justify-center'
        GridStyles='lg:grid-cols-[repeat(2,_minmax(0,_390px))] lg:gap-[17px] lg:grid-start-2 grid-cols-2  gap-[15px] w-[100%] justify-center'
        heading={<Trans>SectionTilesSwiperHeading3</Trans>}
      />
      <SectionBigTile
        containerStyle='lg:pb-[140px] md:pb-[125px] pb-[25px]'
        heading={<Trans>SectionBigTileHeading</Trans>}
        content={<Trans>SectionBigTileContent</Trans>}
        icon1={<Icon33 />}
        icon2={<Icon15 />}
        icon3={<Icon1 />}
      />
      <SectionTextVideo
        id='voyagerTextVideo2'
        styleList='bg-black-100 text-white'
        heading={<Trans>SectionTextVideoHeading2</Trans>}
        content={<Trans>SectionTextVideoContent2</Trans>}
        videoM={MSplitVideo2}
        videoT={TSplitVideo2}
        videoD={DSplitVideo2}
      />
      <SectionOrder
        heading={<Trans>SectionOrderHeading</Trans>}
        link='/contact'
        content={<Trans>SectionOrderContent</Trans>}
      />
      <SelectedProducts
        title={<Trans>SectionSelectedProducts</Trans>}
        end={<Trans>SelectedProductsEnd</Trans>}
        slug='/cs-voyager'
      />
    </>
  )
}

export const Head = () => (
  <Seo
    title='Mobile Car Scanner 360 Voyager | Vumo.ai'
    description='Fully autonomous visual inspection done by a Vumo’s revolutionary robot - Car Scanner Voyager. AI robot for automated and autonomous inspection of cars'
  />
)

export default cs_voyager

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { language: { eq: $language }, ns: { eq: "cs_voyager" } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
